import React from 'react';

const PartnersBanner: React.FC = () => {
  const partners = [
    { name: 'Tenable', logo: '🔍', category: 'Vulnerability Management' },
    { name: 'Claroty', logo: 'https://res.cloudinary.com/durgvddoz/image/upload/v1755771317/claroty-logo-png_seeklogo-455766_thfzag.png', category: 'Industrial Cybersecurity' },
    { name: 'IXDen', logo: '🌐', category: 'Network Security' },
    { name: 'Element Security', logo: '🔬', category: 'Security Testing' },
    { name: 'Palo Alto Networks', logo: '🔥', category: 'Next-Gen Firewall' },
    { name: 'Splunk', logo: '📊', category: 'SIEM & Analytics' },
    { name: 'SentinelOne', logo: '🤖', category: 'AI-Powered EDR' },
    { name: 'Dragos', logo: '⚙️', category: 'Industrial Security' },
    { name: 'Group-IB', logo: '🕵️', category: 'Threat Intelligence' },
    { name: 'LogRhythm', logo: '📈', category: 'Security Analytics' },
    { name: 'Fortinet', logo: '🛡️', category: 'Security Fabric' },
    { name: 'Zscaler', logo: '☁️', category: 'Cloud Security' },
    { name: 'Cisco', logo: '🌐', category: 'Network Infrastructure' },
    { name: 'StealthMole', logo: '🕳️', category: 'Dark Web Intelligence' },
    { name: 'Sophos', logo: '🔒', category: 'Endpoint Protection' },
    { name: 'CrowdStrike', logo: '🦅', category: 'Cloud-Native Security' },
    { name: 'F5', logo: '🚀', category: 'Application Security' },
    { name: 'Nozomi Networks', logo: '🔗', category: 'OT Security' },
    { name: 'Maltego', logo: '🕸️', category: 'OSINT & Investigation' },
    { name: 'Clarity Cyber', logo: '💎', category: 'Cyber Risk Management' },
    { name: 'AlgoSec', logo: '🔐', category: 'Security Policy Management' },
    { name: 'FireMon', logo: '🔥', category: 'Security Orchestration' }
  ];

  return (
    <section className="py-16 bg-slate-50 overflow-hidden">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12">
          <h2 className="text-3xl md:text-4xl font-bold text-slate-900 mb-4">
            🤝 Solution Partners
          </h2>
          <p className="text-xl text-slate-600 max-w-3xl mx-auto">
            Partnering with world-class cybersecurity vendors to deliver comprehensive security solutions
          </p>
        </div>
        
        <div className="relative">
          <div className="flex animate-scroll-reverse space-x-8">
            {/* First set of partners */}
            {partners.map((partner, index) => (
              <div
                key={index}
                className="flex-shrink-0 bg-slate-50 rounded-xl shadow-sm border border-slate-200 p-6 w-72 hover:shadow-lg transition-shadow"
              >
                <div className="text-center">
                  {partner.logo.startsWith('http') ? (
                    <div className="h-16 w-16 mx-auto mb-3 flex items-center justify-center">
                      <img 
                        src={partner.logo} 
                        alt={`${partner.name} logo`}
                        className="max-h-full max-w-full object-contain"
                      />
                    </div>
                  ) : (
                    <div className="text-4xl mb-3">{partner.logo}</div>
                  )}
                  <h3 className="font-semibold text-slate-900 mb-1">{partner.name}</h3>
                  <p className="text-sm text-blue-600">{partner.category}</p>
                </div>
              </div>
            ))}
            {/* Duplicate set for seamless scrolling */}
            {partners.map((partner, index) => (
              <div
                key={`duplicate-${index}`}
                className="flex-shrink-0 bg-slate-50 rounded-xl shadow-sm border border-slate-200 p-6 w-72 hover:shadow-lg transition-shadow"
              >
                <div className="text-center">
                  {partner.logo.startsWith('http') ? (
                    <div className="h-16 w-16 mx-auto mb-3 flex items-center justify-center">
                      <img 
                        src={partner.logo} 
                        alt={`${partner.name} logo`}
                        className="max-h-full max-w-full object-contain"
                      />
                    </div>
                  ) : (
                    <div className="text-4xl mb-3">{partner.logo}</div>
                  )}
                  <h3 className="font-semibold text-slate-900 mb-1">{partner.name}</h3>
                  <p className="text-sm text-blue-600">{partner.category}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
      
      <style>{`
        .animate-scroll-reverse {
          animation: scroll-reverse 35s linear infinite;
        }
        @keyframes scroll-reverse {
          0% { transform: translateX(-50%); }
          100% { transform: translateX(0); }
        }
      `}</style>
    </section>
  );
};

export default PartnersBanner;